export const handleImageUpload = (
  file: File | null | undefined,
  onResult: (dataUrl: string) => void,
  maxMB = 3
): void => {
  if (!file) return;
  if (file.size > maxMB * 1024 * 1024) {
    alert(`Image is too large. Please use an image under ${maxMB}MB.`);
    return;
  }
  const reader = new FileReader();
  reader.onloadend = () => onResult(reader.result as string);
  reader.readAsDataURL(file);
};
